import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("h1", { class: "mb-5" }, "New in Iceberg"),
  /*#__PURE__*/_createVNode("a", {
    class: "btn btn-primary btn-lg",
    href: "https://www.notion.so/What-s-New-in-Iceberg-5d8dca5d39e748528b9adc933549a3af",
    target: "_blank"
  }, "Checkout the latest")
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
}